import { render, staticRenderFns } from "./helpCouponActDetail.vue?vue&type=template&id=596ea8c8&scoped=true&"
import script from "./helpCouponActDetail.vue?vue&type=script&lang=js&"
export * from "./helpCouponActDetail.vue?vue&type=script&lang=js&"
import style0 from "./helpCouponActDetail.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./helpCouponActDetail.vue?vue&type=style&index=1&id=596ea8c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596ea8c8",
  null
  
)

component.options.__file = "helpCouponActDetail.vue"
export default component.exports